import styles from './Decision.module.css';

const DeclinedDecision = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        Sorry, we can’t approve your application today
      </h1>
      <p className={styles.declineInfo}>
        If you’d like to speak to us, or if you have any questions, give us a
        ring on{' '}
        <a href="tel:02037780105" target="_blank" rel="noreferrer">
          020 3778 0105
        </a>
      </p>
    </div>
  );
};

export default DeclinedDecision;
